import { call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { LOCATION_CHANGE } from 'react-router-redux';

import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';

// Actions
export const FETCH_PAYMENT_EVENTS = 'FETCH_PAYMENT_EVENTS';
export const FETCH_PAYMENT_EVENTS_SUCCESS = 'FETCH_PAYMENT_EVENTS_SUCCESS';
export const FETCH_PAYMENT_EVENTS_FAIL = 'FETCH_PAYMENT_EVENTS_FAIL';

// Reducer
export default function paymentEventsReducer(state = { data: {}, loading: 0 }, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_PAYMENT_EVENTS:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case FETCH_PAYMENT_EVENTS_SUCCESS:
      return {
        ...state,
        ...payload,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case FETCH_PAYMENT_EVENTS_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        loading: 0,
      };
    default:
      return state;
  }
}

// Action Creators
export function fetchPaymentEvents(payload) {
  return { type: FETCH_PAYMENT_EVENTS, payload };
}

export function fetchPaymentEventsSuccess(payload) {
  return { type: FETCH_PAYMENT_EVENTS_SUCCESS, payload };
}

export function fetchPaymentEventsFail(payload) {
  return { type: FETCH_PAYMENT_EVENTS_FAIL, payload };
}

// Requests
export function requestFetchPaymentEvents({ limit, offset, sortBy = [] }) {

  return callApi('stripe/payment/events/', 'POST', {
    sort_by: [
      ...sortBy,
      {
        name: 'Create At',
        sort: 'desc',
      },
    ],
    limit,
    offset,
  });
}

// Sagas
function* fetchPaymentEventsSaga(action) {
  const { limit, offset, triggerLoading } = action.payload;
  try {
    const res = yield call(requestFetchPaymentEvents, {
      limit,
      offset,
    });
    yield put(fetchPaymentEventsSuccess({
      data: res.data,
      count: res.count,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res.user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
  } catch (err) {
    yield put(fetchPaymentEventsFail({
      ...err.data,
      triggerLoading,
    }));
  }
}

export function* paymentEventsSaga() {
  yield takeEvery(FETCH_PAYMENT_EVENTS, fetchPaymentEventsSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/paymentEvents.js